import { useState } from "react";
import { toast } from "react-toastify";
import apiClient from "../../../api/apiClient";
import { handleErrors } from "../../../modules/handleErrors";
import { generateUUID } from "../utils/helpers";

const domain = process.env.REACT_APP_DOMAIN || 'https://www.mockee.io';
export const useSharableLink = () => {
  const [loader, setloader] = useState(false);

  const handleSharableLink = async (e, id, link) => {
    e.preventDefault();
    if (link) {
      try {
        await navigator.clipboard.writeText(
          `${domain}/shared/mockup-editor?link=${link}`
        );
        toast.success("Sharable link copied to clipboard!");
      } catch (err) {
        toast.error("Failed to copy link");
      }
      return;
    }
    setloader(true);
    const sharable_link_id = generateUUID();
    const uploaddata = new FormData();
    uploaddata.append("sharable_link_id", sharable_link_id);

    try {
      const result = await apiClient.patch(`/listings/${id}/`, uploaddata);
      if (!result.ok) return handleErrors(result.data);
      await navigator.clipboard.writeText(
        `${domain}/shared/mockup-editor?link=${result?.data?.sharable_link_id}`
      );
      toast.success("Sharable link copied to clipboard!");
      setloader(false);
    } catch (error) {
      setloader(false);
    }
  };

  return { handleSharableLink, loader };
};

